import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../app/theme';
import {
  GATriggerType,
  ProviderType,
  TriggerFlowModeType,
  TriggerType,
} from '../../app/types';
import Mask from './SettingBarMask';
import Birthday from './triggerSetting/Birthday';
import CustomFieldDate from './triggerSetting/CustomFieldDate';
import ProviderAction from './triggerSetting/ec/ProviderAction';
import Flow from './triggerSetting/Flow';
import GAEvent from './triggerSetting/GAEvent';
import GATip from './triggerSetting/GATip';
import GAView from './triggerSetting/GAView';
import Keywords from './triggerSetting/Keywords';
import PlatformTip from './triggerSetting/PlatformTip';
import Rule from './triggerSetting/Rule';
import Tags from './triggerSetting/Tags';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
  },
  {
    name: 'TriggerSetting',
  },
);

const TriggerSetting = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { platform } = useSelector(state => state.ma?.data);
  const { provider } = useSelector(state => state.superMarket.EC);
  const { data } = selectedNode || {};
  const { type } = data || {};

  const ContentComponent = useMemo(() => {
    switch (type) {
      case TriggerType.ADD:
        return null;
      case TriggerType.UNBLOCK:
        return null;
      case TriggerType.KEYWORD:
        return <Keywords />;
      case TriggerType.TAG:
        return <Tags />;
      case GATriggerType.GAVIEW:
        return (
          <>
            <GAEvent />
            <GAView />
          </>
        );
      case GATriggerType.GAREMOVEFROMCART:
      case GATriggerType.GAADDTOCART:
      case GATriggerType.GAPURCHASE:
        return (
          <>
            <GAEvent />
            <GATip />
          </>
        );
      case TriggerFlowModeType.BOT:
      case TriggerFlowModeType.SUPERLINK:
      case TriggerFlowModeType.PROCEDURE:
      case TriggerFlowModeType.API:
        return <Flow />;
      case TriggerType.BIRTHDAY:
        return <Birthday />;
      case TriggerType.CUSTOM_FIELD_DATE:
        return <CustomFieldDate />;
      case ProviderType.SHOPLINE:
      case ProviderType.SHOPIFY:
      case ProviderType.CYBERBIZ:
      case ProviderType.SALESFORCE:
        return <ProviderAction />;
      default:
        return null;
    }
  }, [type, platform, provider]);

  return (
    <>
      <div className={classes.top}>{t('trigger-node')}</div>
      <div id="trigger-setting-bar-bottom" className={classes.bottom}>
        <Rule />
        {ContentComponent}
        <PlatformTip />
      </div>
      <Mask mainId="trigger-setting-bar-bottom" />
    </>
  );
};

export default TriggerSetting;
